import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const sepolia: VToken[] = [
  {
    chainId: 11155111,
    address: "0x74E708A7F5486ed73CCCAe54B63e71B1988F1383",
    decimals: 8,
    symbol: "vWBTC_Core",
    underlyingToken: tokens[11155111][2]!,
  },
  {
    chainId: 11155111,
    address: "0xc2931B1fEa69b6D6dA65a50363A8D75d285e4da9",
    decimals: 8,
    symbol: "vWETH_Core",
    underlyingToken: tokens[11155111][3]!,
  },
  {
    chainId: 11155111,
    address: "0xF87bceab8DD37489015B426bA931e08A4D787616",
    decimals: 8,
    symbol: "vUSDC_Core",
    underlyingToken: tokens[11155111][5]!,
  },
  {
    chainId: 11155111,
    address: "0x19252AFD0B2F539C400aEab7d460CBFbf74c17ff",
    decimals: 8,
    symbol: "vUSDT_Core",
    underlyingToken: tokens[11155111][4]!,
  },
  {
    chainId: 11155111,
    address: "0xA09cFAd2e138fe6d8FF62df803892cbCb79ED082",
    decimals: 8,
    symbol: "vcrvUSD_Core",
    underlyingToken: tokens[11155111][7]!,
  },
  {
    chainId: 11155111,
    address: "0x121E3be152F283319310D807ed847E8b98319C1e",
    decimals: 8,
    symbol: "vCRV_Core",
    underlyingToken: tokens[11155111][6]!,
  },
  {
    chainId: 11155111,
    address: "0xfe050f628bF5278aCfA1e7B13b59fF207e769235",
    decimals: 8,
    symbol: "vDAI_Core",
    underlyingToken: tokens[11155111][11]!,
  },
  {
    chainId: 11155111,
    address: "0xE23A1fC1545F1b072308c846a38447b23d322Ee2",
    decimals: 8,
    symbol: "vTUSD_Core",
    underlyingToken: tokens[11155111][10]!,
  },
  {
    chainId: 11155111,
    address: "0x33942B932159A67E3274f54bC4082cbA4A704340",
    decimals: 8,
    symbol: "vFRAX_Core",
    underlyingToken: tokens[11155111][12]!,
  },
  {
    chainId: 11155111,
    address: "0x18995825f033F33fa30CF59c117aD21ff6BdB48c",
    decimals: 8,
    symbol: "vsFRAX_Core",
    underlyingToken: tokens[11155111][13]!,
  },
  {
    chainId: 11155111,
    address: "0x7C4890D673985CE22A4D38761473f190e434c956",
    decimals: 8,
    symbol: "vsfrxETH_LiquidStakedETH",
    underlyingToken: tokens[11155111][16]!,
  },
  {
    chainId: 11155111,
    address: "0x6DB4aDbA8F144a57a397b57183BF619e957040B1",
    decimals: 8,
    symbol: "vEIGEN",
    underlyingToken: tokens[11155111][20]!,
  },
  {
    chainId: 11155111,
    address: "0x8E6241389e823111259413810b81a050bd45e5cE",
    decimals: 8,
    symbol: "veBTC",
    underlyingToken: tokens[11155111][21]!,
  },
  {
    chainId: 11155111,
    address: "0x315F064cF5B5968fE1655436e1856F3ca558d395",
    decimals: 8,
    symbol: "vLBTC_Core",
    underlyingToken: tokens[11155111][22]!,
  },
  {
    chainId: 11155111,
    address: "0x459C6a6036e2094d1764a9ca32939b9820b2C8e0",
    decimals: 8,
    symbol: "vUSDS_Core",
    underlyingToken: tokens[11155111][27]!,
  },
  {
    chainId: 11155111,
    address: "0x083a24648614df4b72EFD4e4C81141C044dBB253",
    decimals: 8,
    symbol: "vsUSDS_Core",
    underlyingToken: tokens[11155111][26]!,
  },
  {
    chainId: 11155111,
    address: "0xD4B82B7B7CdedB029e0E58AC1B6a04F6616BEd40",
    decimals: 8,
    symbol: "vBAL_Core",
    underlyingToken: tokens[11155111][28]!,
  },
  {
    chainId: 11155111,
    address: "0x4bC731477aF00ea83C5eCbAc31E1E9fF85eD8A1e",
    decimals: 8,
    symbol: "vyvUSDC-1_Core",
    underlyingToken: tokens[11155111][29]!,
  },
  {
    chainId: 11155111,
    address: "0x9Ec91759d4EBaDE3109cCAD1B7AE199a02312c10",
    decimals: 8,
    symbol: "vyvUSDT-1_Core",
    underlyingToken: tokens[11155111][30]!,
  },
  {
    chainId: 11155111,
    address: "0x5e2fB6a1e1570eB61360E87Da44979cb932090B0",
    decimals: 8,
    symbol: "vyvUSDS-1_Core",
    underlyingToken: tokens[11155111][31]!,
  },
  {
    chainId: 11155111,
    address: "0x271D914014Ac2CD8EB89a4e106Ac15a4e948eEE2",
    decimals: 8,
    symbol: "vyvWETH-1_Core",
    underlyingToken: tokens[11155111][32]!,
  },
  {
    chainId: 11155111,
    address: "0x81aab41B868f8b5632E8eE6a98AdA7a7fDBc8823",
    decimals: 8,
    symbol: "vweETHs_Core",
    underlyingToken: tokens[11155111][18]!,
  },
  {
    chainId: 11155111,
    address: "0x33e4C9227b8Fca017739419119BbBA33A089D4a0",
    decimals: 8,
    symbol: "vsUSDe_Core",
    underlyingToken: tokens[11155111][23]!,
  },
  {
    chainId: 11155111,
    address: "0x36e8955c305aa48A99e4c953C9883989a7364a42",
    decimals: 8,
    symbol: "vUSDe_Core",
    underlyingToken: tokens[11155111][34]!,
  },
  {
    chainId: 11155111,
    address: "0x834078D691d431aAdC80197f7a61239F9F89547b",
    decimals: 8,
    symbol: "vtBTC_Core",
    underlyingToken: tokens[11155111][33]!,
  },
  {
    chainId: 11155111,
    address: "0xD5f83FCbb4a62779D0B37b9E603CD19Ad84884F0",
    decimals: 8,
    symbol: "vUSDC_Stablecoins",
    underlyingToken: tokens[11155111][5]!,
  },
  {
    chainId: 11155111,
    address: "0x93dff2053D4B08823d8B39F1dCdf8497f15200f4",
    decimals: 8,
    symbol: "vUSDT_Stablecoins",
    underlyingToken: tokens[11155111][4]!,
  },
  {
    chainId: 11155111,
    address: "0x9C5e7a3B4db931F07A6534f9e44100DDDc78c408",
    decimals: 8,
    symbol: "vcrvUSD_Stablecoins",
    underlyingToken: tokens[11155111][7]!,
  },
  {
    chainId: 11155111,
    address: "0xc7be132027e191636172798B933202E0f9CAD548",
    decimals: 8,
    symbol: "vcrvUSD_Curve",
    underlyingToken: tokens[11155111][7]!,
  },
  {
    chainId: 11155111,
    address: "0x9Db62c5BBc6fb79416545FcCBDB2204099217b78",
    decimals: 8,
    symbol: "vCRV_Curve",
    underlyingToken: tokens[11155111][6]!,
  },
  {
    chainId: 11155111,
    address: "0x0a95088403229331FeF1EB26a11F9d6C8E73f23D",
    decimals: 8,
    symbol: "vwstETH_LiquidStakedETH",
    underlyingToken: tokens[11155111][8]!,
  },
  {
    chainId: 11155111,
    address: "0x9f6213dFa9069a5426Fe8fAE73857712E1259Ed4",
    decimals: 8,
    symbol: "vWETH_LiquidStakedETH",
    underlyingToken: tokens[11155111][3]!,
  },
  {
    chainId: 11155111,
    address: "0x30c31bA6f4652B548fe7a142A949987c3f3Bf80b",
    decimals: 8,
    symbol: "vweETH_LiquidStakedETH",
    underlyingToken: tokens[11155111][9]!,
  },
  {
    chainId: 11155111,
    address: "0x83F63118dcAAdAACBFF36D78ffB88dd474309e70",
    decimals: 8,
    symbol: "vsfrxETH_LiquidStakedETH",
    underlyingToken: tokens[11155111][16]!,
  },
  {
    chainId: 11155111,
    address: "0xF4C1B7528f8B266D8ADf1a85c91d93114FeDbA2A",
    decimals: 8,
    symbol: "vezETH_LiquidStakedETH",
    underlyingToken: tokens[11155111][17]!,
  },
  {
    chainId: 11155111,
    address: "0xB3A201887396F57bad3fF50DFd02022fE1Fd1774",
    decimals: 8,
    symbol: "vweETHs_LiquidStakedETH",
    underlyingToken: tokens[11155111][18]!,
  },
  {
    chainId: 11155111,
    address: "0x1E4d64B7c6f1F71969E5137B5Ee8cBa9Ab9c9356",
    decimals: 8,
    symbol: "vpufETH_LiquidStakedETH",
    underlyingToken: tokens[11155111][19]!,
  },
];
